<template>
  <Breadcrumb></Breadcrumb>
  <PurchaseOfferForm :purchaseOffer="purchaseOffer" :title="$gettext('Nouvelle offre d\'achat')" @submit="onSubmit" @cancel="onCancel" />
</template>

<script setup>
import { usePurchaseOfferStore } from "@/stores/purchaseOffer";
import { useRouter, useRoute } from "vue-router";
import Breadcrumb from "@/components/layout/BreadcrumbNavigation.vue";
import PurchaseOfferForm from "@/components/purchase-offers/PurchaseOfferForm.vue";

const router = useRouter();
const route = useRoute();
const saleListingAgreementId = route.query.saleListingAgreementId;
const propertyId = route.query.propertyId;

const purchaseOfferStore = usePurchaseOfferStore();
const purchaseOffer = purchaseOfferStore.empty;

const onSubmit = (payload, actions) => {
  purchaseOfferStore.save(payload, saleListingAgreementId, propertyId, () => {
    router.push({ name: "sale-listing-agreement", params: { id: saleListingAgreementId } });
  }, (errors) => {
    actions.setErrors(errors.value);
  });
};

const onCancel = () => {
  router.back();
};

</script>
